import { useRef } from 'react';

/**
 * useScrollRestore
 * Call save() before opening a modal/drawer, and restore() after closing it.
 * Example:
 *   const { save, restore } = useScrollRestore();
 *   // onOpen: save();
 *   // onClose: restore();
 */
export function useScrollRestore() {
  const scrollRef = useRef(0);

  function save() {
    scrollRef.current = window.scrollY;
  }

  function restore(delay = 10) {
    setTimeout(() => {
      window.scrollTo(0, scrollRef.current || 0);
    }, delay);
  }

  return { save, restore };
}
